/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OpenSessionBody { 
    /**
     * INS du patient
     */
    ins: string;
    /**
     * OID du patient
     */
    oid: string;
    /**
     * Index du slot du lecteur où se trouve la carte CPX
     */
    slot?: number;
    /**
     * Code PIN de la carte CPX
     */
    pin: string;
    /**
     * Index de la situation courante sur la carte (les situation sont récupérables avec la route \"/dmp/transaction/session/situations\")
     */
    situationCourante: number;
    /**
     * Accès au DMP en mode secret (pour les patients mineurs)
     */
    modeSecret: boolean;
    /**
     * Identifiant de l\'utilisateur qui ouvre la session (dans le cas d\'une utilisation de la carte CPE)
     */
    identiteUtilisateur?: string;
}

